import React, { useEffect, useRef } from 'react';
import { message } from 'antd';
import { connect } from 'react-redux';
import intl from 'react-intl-universal';

const AuthBtn = ({ permissions, children }) => {
  const ref = useRef<any>();

  useEffect(() => {
    const handleClick = (e) => {
      let ele = e.target;
      while (ele && !ele.className?.includes('authContainer') && !('authkey' in ele.dataset)) {
        ele = ele.parentNode;
      }
      //  不需要权限的
      if (
        !ele ||
        ele.className?.includes('authContainer') ||
        ele.dataset?.authkey === 'noPermissionsRequired'
      ) {
        return;
      }
      if (!permissions?.includes(ele.dataset?.authkey)) {
        message.error(intl.get('app_permission_denied'));
        e.stopPropagation();
      }
    };

    ref.current?.addEventListener('click', handleClick, true);

    return () => {
      ref.current?.removeEventListener('click', handleClick);
    };
  }, [permissions]);

  return (
    <>
      <div
        className="authContainer"
        ref={ref}
        style={{ display: 'inline-flex', alignItems: 'center', flexWrap: 'wrap' }}
      >
        {children}
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  const { permissions } = state.user;
  return { permissions };
};

export default connect(mapStateToProps, {})(React.memo(AuthBtn));
